import { Component, Input } from '@angular/core';
import { environment } from '@environments/environment';
import { IntlService } from '@progress/kendo-angular-intl';
import { BaseCardComponent } from "./base-card.component";
import { Router } from '@angular/router';


@Component({
  selector: 'vehicle-card',
  styleUrls: ['./styles/styles-card.css'],
  styles: [`
    .card {
      height: 92px;
    }
    .card-1 {
      height: 92px;
    }
    .card-2 {
      height: 110px;
    }
    .card-3 {
      height: 232px;
    }
    .card-details {
      width: 75%;
    }
  `],
  template: `
    <!--{{vehicle | json}}-->
    <div class="card {{ (!action) ? 'card-' + vehicle.id_vehicle_status : '' }}" [class.border-top]="borderTop" (click)="selectItem($event)">
      <kendo-avatar [imageSrc]="(vehicle.vehicle_type_image != '') ? vehicle.vehicle_type_image: defaultImage" shape="circle" style="padding: 4px; background-color: #{{ vehicle.vehicle_status_color }}"></kendo-avatar>
      <div class="card-details">
        <div class="card-title">
          {{ vehicle.sku_exp }} / {{ vehicle.sku_inv }} <span class="right">{{ getDate(vehicle.entry_date) }}</span>
        </div>
        <div class="card-subtitle">
          {{ vehicle.marck }}, {{ vehicle.color }} - {{ vehicle.plaque }}
        </div>
        <div class="card-subtitle no-wrap">
          {{ vehicle.place }}
        </div>
        <div class="card-subtitle no-wrap">
          {{ vehicle.deposit_name }}, {{ vehicle.authority_abbreviation }} - {{ vehicle.authority_name }}
        </div>
        <div class="card-subtitle no-wrap">
          SERIE: {{ vehicle.serie }}
        </div>
        <div class="card-subtitle no-wrap" *ngIf="!action">
          {{ vehicle.vehicle_type_name }}
        </div>
        <div class="card-subtitle no-wrap" *ngIf="!action && vehicle.id_vehicle_status >= 2">
          COSTO DE GRÚA: <span class="right">{{ intl.formatNumber(vehicle.cost_crane, "c2") }}</span>
        </div>  
        <div class="card-subtitle no-wrap" *ngIf="!action && vehicle.id_vehicle_status == 3">
          COSTO PENSIÓN: ({{ vehicle.days }} días x {{ intl.formatNumber(vehicle.vehicle_type_fee, "c2") }}) <span class="right">{{ intl.formatNumber(vehicle.cost_pension, "c2") }}</span>
        </div>
        <div class="card-subtitle no-wrap" *ngIf="!action && vehicle.id_vehicle_status == 3">
          SUBTOTAL: <span class="right">{{ intl.formatNumber(vehicle.cost_subtotal, "c2") }}</span>
        </div> 
        <div class="card-subtitle no-wrap" *ngIf="!action && vehicle.id_vehicle_status == 3">
          IVA: (16%) <span class="right">{{ intl.formatNumber(vehicle.cost_iva, "c2") }}</span>
        </div>
        <div class="card-subtitle no-wrap" *ngIf="!action && vehicle.id_vehicle_status == 3">
          COSTO TOTAL: <span class="right">{{ intl.formatNumber(vehicle.cost_total, "c2") }}</span>
        </div> 
        <div class="card-subtitle no-wrap" *ngIf="!action && vehicle.id_vehicle_status == 3">
          DESCUENTO: ({{ intl.formatNumber(vehicle.cost_discount_perc, "p2") }}) <span class="right">{{ intl.formatNumber(vehicle.cost_discount, "c2") }}</span>
        </div>
        <div class="card-title no-wrap" *ngIf="!action && vehicle.id_vehicle_status == 3">
          <span class="right">{{ intl.formatNumber(vehicle.cost_paid, "c2") }}</span>
        </div>
        <div class="card-subtitle no-wrap" *ngIf="!action && vehicle.id_vehicle_status == 3">
          {{ vehicle.payment_type_name }}
        </div>
        <div class="card-subtitle no-wrap" *ngIf="!action && vehicle.id_vehicle_status == 3">
          {{ vehicle.person_name }}
        </div>              
        <div class="card-subtitle no-wrap" *ngIf="!action">
          {{ vehicle.observations }}
        </div>
      </div>
      <div class="card-actions" *ngIf="action">                
        <span class="k-icon k-icon-md k-i-arrow-chevron-right" style="color: #{{ vehicle.vehicle_status_color }}"></span>
      </div>
    </div>
  `,    
})
export class VehicleCardComponent extends BaseCardComponent {

  @Input() vehicle!: any;

  @Input() action: boolean = true;

  @Input() defaultImage: string = environment.assets.DEFAULT_VEHICLE;

  @Input() returnUrl: string;


  constructor(public intl: IntlService, public router: Router) { 

    super(intl, router)

  }  
  
  public selectItem(event: any) {
    
    this.router.navigate(['/vehicle_actions/' + this.vehicle.id], {state: {returnUrl: this.returnUrl}});

  }

}